import { Component, OnInit, QueryList, ViewChildren, ViewChild, OnDestroy } from '@angular/core';
import { ClaimListByAccountCriteria } from './_models/claim-list-by-account-criteria';
import { BehaviorSubject } from 'rxjs';
import { SortableDirective, SortEvent } from 'src/app/_directives/sortable.directive';
import { ClaimService } from 'src/app/_services/claim.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HeaderData } from 'src/app/_models/header-data';
import { RESULTS_NOT_FOUND } from 'src/app/_common/product-config';
import { StatusCode, Modules } from 'src/app/_common/_enum/module.enum';
import { AccountService } from '../_services/account.service';
import { PolicyListByAccountCriteria } from '../policy-list-by-account/_models/policy-list-by-account-criteria';

@Component({
  selector: 'app-claim-list-by-account',
  templateUrl: './claim-list-by-account.component.html',
  styleUrls: ['./claim-list-by-account.component.scss']
})
export class ClaimListByAccountComponent implements OnInit, OnDestroy {
  resultsNotFound = RESULTS_NOT_FOUND;
  private criteria: ClaimListByAccountCriteria;
  private claims = [];
  private claimList = [];
  //private hasClaims: boolean = true;
  private hasAccess: boolean = true;
  private _total$ = new BehaviorSubject<number>(0);
  private loading: boolean = false;
  private filterObj: Object[];

  private accountNumber;
  private selectedAccount;
  private selectedLossDate;
  private selectedStatus;
  private reportLoading: boolean = false;

  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;

  //private killServicesOnDestroy = [];
  
  @ViewChildren(SortableDirective) headers: QueryList<SortableDirective>;
  @ViewChild("lossRunErrorModal", {static: false}) lossRunErrorModal;
  @ViewChild("lossRunMessageModal", {static: false}) lossRunMessageModal;

  constructor(private readonly route: ActivatedRoute, private router: Router, private claimService: ClaimService, private accountService: AccountService) { }

  ngOnInit() {
    this.filterObj = [
      {filterIndex: 0, displayName : 'All', value: '', group: 'ClaimStatus'},
      {filterIndex: 1, displayName : 'Open Claims', value: 'Open', group: 'ClaimStatus'},
      {filterIndex: 2, displayName : 'Closed Claims', value: 'Closed', group: 'ClaimStatus'},
      {filterIndex: 3, displayName : 'All', value: '', group: 'DateOfLoss'},
      {filterIndex: 4, displayName : 'Past 30 Days', value: 'Past30Days', group: 'DateOfLoss'},
      {filterIndex: 5, displayName : 'Past 60 Days', value: 'Past60Days', group: 'DateOfLoss'},
      {filterIndex: 6, displayName : 'Past 90 Days', value: 'Past90Days', group: 'DateOfLoss'},
      {filterIndex: 7, displayName : 'Past 120 Days', value: 'Past120Days', group: 'DateOfLoss'},
    ];
    this.criteria = new ClaimListByAccountCriteria();
    
    //Getting Policy Number for State params
    this.route.paramMap.subscribe(params => {
      this.accountNumber = params.get("id").toString();
    });
    this.selectedLossDate = this.filterObj.find((obj:any) => {return obj.group == 'DateOfLoss' && obj.displayName == 'All'});
    this.selectedStatus = this.filterObj.find((obj:any) => {return obj.group == 'ClaimStatus' && obj.displayName == 'All'});

    this.selectedAccount = this.claimService.getAccountData();
    
    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    //this.setHeaderData();
    /* Setting Headers Ended */

    this.showEndorsementsTab();

    this.retrieveBasicHeaderData(); //Retrieve the basic details of account and Set the Header..
    this.resetCriteria();
    this.fetchClaims();
  }
  
  retrieveBasicHeaderData(){
    /* Setting Headers Starts */
    this.headerData = new HeaderData();

    this.selectedAccount = this.accountService.getAccountData();
    if(!this.selectedAccount || this.selectedAccount.accountNumber !== this.accountNumber){
      this.loading = true;
      //this.hasClaims = true;
      
      let filters:PolicyListByAccountCriteria = new PolicyListByAccountCriteria();
      filters.accountNumber = this.accountNumber;
      filters.sortBy = "accountName";
      filters.sortOrder = "asc";
      let accountByAccountSubscription = this.accountService.fetchAccountByAccountNumber(filters).subscribe((accountData:any)=>{
        if(accountData.policies && accountData.policies.length > 0){
          this.selectedAccount = accountData.policies[0];
          this.accountService.storeAccountData({"accountName": this.selectedAccount.accountName, "accountNumber": this.selectedAccount.accountNumber, "accountEndorsementsTab": ((this.selectedAccount && this.selectedAccount.accountEndorsementsTab != null)?this.selectedAccount.accountEndorsementsTab: null)});
        }
        this.setHeaderData();
      },error=>{
        this.setHeaderData();
        this.hasAccess = !(error.status == StatusCode.NoAccess);
      });

      this.accountService.runningServices.push(accountByAccountSubscription);
    }else{
      this.setHeaderData();
    }
    /* Setting Headers Ended */
  }

  setHeaderData(){
    this.headerData.pageTitle = this.selectedAccount.accountName;//.toLowerCase();
    this.headerData.breadcrumb = [{itemName: "Account Overview", itemLink: ""}];
    this.headerData.subTitle = "Account #: " + this.selectedAccount.accountNumber;
    this.claimService.header = this.headerData;  
  }

  showEndorsementsTab(){    
    let getEndtFlag = this.accountService.endtTabFlag(this.selectedAccount).subscribe( (result: boolean) => { this.selectedAccount.accountEndorsementsTab = result });
    this.accountService.runningServices.push(getEndtFlag);
  }

  fetchClaims(){
    this.loading = true;
    //this.hasClaims = true;
    this.hasAccess = true;
    let claimsSubscription = this.claimService.fetchClaims(this.criteria).subscribe((claims:any) => {
      this.loading = false;
      this._total$.next(claims.totalClaims);
      this.claimList = claims.claims;
      this.claims = JSON.parse(JSON.stringify(this.claimList));// Object.assign({}, this.claimList);
      //this.hasClaims = this.claims && this.claims.length > 0;
      
      this.claims = this.doSort(this.criteria.sortBy, this.criteria.sortOrder);

      console.log(this._total$);
    },error=>{
      this.loading = false;
      //this.hasClaims = false;
      this.claims = null;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });

    this.accountService.runningServices.push(claimsSubscription);
  }

  get total$() { return this._total$.asObservable(); }

  get ModuleEnum(){ return Modules; }
  
  /* ***Filter Code*** */
  onFilter(_selectedLossDate, _selectedClaimStatus){
    this.loading = true;
    this.selectedLossDate=_selectedLossDate;
    this.selectedStatus=_selectedClaimStatus
    if(_selectedLossDate.value == '' && _selectedClaimStatus.value == ''){
      this.loading = false;
      this.claims = JSON.parse(JSON.stringify(this.claimList)); 
    }else{
      this.loading = false;
        var filterDate, today, days;
        switch(_selectedLossDate.value.toLowerCase()){
          case "past30days":
            days = 30;
            break;
          case "past60days":
            days = 60;
            break;
          case "past90days":
            days = 90;
            break;
          case "past120days":
            days = 120;
            break;
          case "":
            days = 10000;
            break;
        }
        today = new Date();
        filterDate = new Date();
        filterDate = new Date(filterDate.setDate(filterDate.getDate() - days));

        this.claims = this.claimList.filter(claim => new Date(claim.claimDateOfLoss) > filterDate && new Date(claim.claimDateOfLoss) < today);
        this.claims = this.claims.filter(claim => this.matches(claim, _selectedClaimStatus));
    }

    this.claims = this.doSort(this.criteria.sortBy, this.criteria.sortOrder);
    
    this._total$.next(this.claims.length);
  }

  matches(claim: any, item: any) {
    let grp = item.group.replace(/\s(.)/g, function($1) { return $1.toUpperCase(); }).replace(/\s/g, '').replace(/^(.)/, function($1) { return $1.toLowerCase(); });
    return claim[grp].toLowerCase().includes( item.value.toLowerCase())
  }
  /* Filter Code */
  
  /* ***Sorting Code*** */
  compare(v1, v2) {
    return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
  }

  onSort({column, direction}: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    if (direction !== '') {
      this.criteria.sortOrder = direction;
      this.criteria.sortBy = column;
      this.criteria.pageNo = 1;

      console.log("Call WebAPI to sort " + column + " column in " + direction + " order");
      return this.doSort(column, direction);
    }
  }

  doSort(column, direction){
    return this.claims.sort((a, b) => {
      const res = this.compare(a[column], b[column]);
      return direction === 'asc' ? res : -res;
    });
  }
  /* Sorting Code */

  resetCriteria(){
    if(!this.selectedAccount || this.selectedAccount.accountNumber !== this.accountNumber){
      this.criteria.accountNumber = this.accountNumber;//this.selectedAccount.accountNumber;
    }else{
      this.criteria.accountNumber = this.selectedAccount.accountNumber;
    }
    this.criteria.sortBy = "claimDateReported";
    this.criteria.sortOrder = "desc";
  }

  getFilteredData(_filter){
    this.selectedLossDate = (_filter.group == "LossDate")? _filter.displayName : "LossDate";
    this.selectedStatus = (_filter.group == "Status")? _filter.displayName : "Status";
    
    this.claims = [];
    this.fetchClaims();
  }

  getClaimStatusClass(status){
    return (status.toLowerCase() === "re-open" || status.toLowerCase() === "reopen" || status.toLowerCase() === "open")?"open":((status.toLowerCase() === "close" || status.toLowerCase() === "closed" || status.toLowerCase() === "cancelled"))?"closed":"";
  }

  openClaimDetails(claim){
    claim.accountName = this.selectedAccount.accountName;
    claim.accountId = this.selectedAccount.accountNumber;
    
    this.claimService.storeClaimData(claim);
    this.router.navigateByUrl("claims/"+claim.claimNumber);
  }

  onPageChange(){
    window.scrollTo(0, 0);
  }

  downloadLossRunReport(type: string){
    this.reportLoading = true;
    this.accountService.openModal('none', this.lossRunMessageModal);
    this.accountService.downloadLossRunReport(this.selectedAccount.accountNumber, (type+"Number")).subscribe(data=>{
      this.reportLoading = false;
      this.accountService.closeModal();
    },
    error => {
      this.reportLoading = false;
      let hasOpenModals = this.accountService.hasOpenModals();
      if (hasOpenModals) {
        this.accountService.closeModal();
      }
      if(error.status == StatusCode.NoAccess) {        
        setTimeout(() => {
          this.accountService.openModal('none', this.lossRunErrorModal);
        }, 50);
        
      } 
      
      if(error.status == StatusCode.InternalServer) {
        setTimeout(() => {
          this.accountService.openModal('error', 'none');
        }, 50);
      }
      console.warn("Download Loss Run Report Error : " + error);
    });
  }
    
  ngOnDestroy() {
    this.accountService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}